import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import processServerErrors from '../helpers/processServerErrors';

function useErrors() {
  const { i18n } = useTranslation();

  const [errors, setErrors] = useState([]);

  function setError(error) {
    const processedError = processServerErrors(error, i18n);

    setErrors([...errors, processedError]);
  }

  return {
    errors,
    setError
  };
}

export default useErrors;
